import pubsub from "pubsub-js";

function subscribe(pubId, callback) {
  return pubsub.subscribe(pubId, callback);
}

// 可以unsubscribe Token/Topic/Function
function unsubscribe(str) {
  pubsub.unsubscribe(str);
}

function publish(pubId, data) {
  pubsub.publish(pubId, data);
}

export {subscribe, unsubscribe, publish};